import { boolean, index, integer, pgTable, timestamp, varchar } from "drizzle-orm/pg-core";

// Ownership/usage ledger, not a copy of Stripe's billing tables. Financial
// terms remain unchanged in Stripe; this records the admin-authorised move.
export const subscriptionTransfers = pgTable("subscription_transfers", {
  id: varchar("id", { length: 36 }).primaryKey(),
  fromUserId: varchar("from_user_id").notNull(),
  toUserId: varchar("to_user_id").notNull(),
  actorUserId: varchar("actor_user_id").notNull(),
  stripeCustomerId: varchar("stripe_customer_id").notNull(),
  stripeSubscriptionId: varchar("stripe_subscription_id").notNull(),
  periodStart: timestamp("period_start").notNull(),
  carriedUsage: integer("carried_usage").notNull(),
  livemode: boolean("livemode").notNull(),
  metadataSyncedAt: timestamp("metadata_synced_at"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
}, (table) => [
  index("idx_subscription_transfers_subscription_period").on(table.stripeSubscriptionId, table.periodStart),
  index("idx_subscription_transfers_from").on(table.fromUserId),
  index("idx_subscription_transfers_to").on(table.toUserId),
]);